import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchAwarenessModule } from "./learningAPI";

export interface AwarenessMState {
  awarenessmodule: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: AwarenessMState = {
    awarenessmodule: [],
  status: "idle",
};

export const GetAwarenessModule = createAsyncThunk(
  "awareness/fetchAwareness",
  async (data:any) => {
    const response = await fetchAwarenessModule(data);
    return response;
  }
);

export const awarenessModuleSlice = createSlice({
  name: "Awareness",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetAwarenessModule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetAwarenessModule.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetAwarenessModule.fulfilled, (state, action) => {
        state.status = "idle";
        state.awarenessmodule = action.payload.material;
       // state.awarenessmodule = state.awarenessmodule.concat(action.payload.material);
      });
  },
});

export const {} = awarenessModuleSlice.actions;

export const selectAwarenessModule = (state: RootState) => {
  return state.AwarenessModule.awarenessmodule;
};

export default awarenessModuleSlice.reducer;
